/**
 * デジタルサイネージコントロール用モジュール
 *
 * @module app/control/SignageControl
 */
define(['module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/topic',
    'dojo/Deferred',
    'dojo/json',
    'idis/control/Router',
    'idis/service/Requester',
    'idis/control/Locator',
    'dojo/on',
    'src/modules/index.js'
], function (module, declare, lang, topic, Deferred, json, Router, Requester, Locator,on) {
    /**
     * デジタルサイネージコントロール
     *
     * @class SignageControl
     * @extends module:idis/control/Router~Router
     */
    return declare(module.id.replace(/\//g, '.'), Router, /** @lends app/control/SignageControl */
        {

            /**
             * 自動更新clearTimeout用のID
             * @type {number}
             */
            _autoUpdateTimeoutId: null,

            _initialUpdate: true,

            _signageIndex: 0,

            // 表示対象のサイネージのリスト
            _signageList: [],

            // 前回表示したサイネージ
            _prevSignage: null,

            // JSON差異有無フラグ
            _differenceJsonFlg: false,

            // JSON差異チェック間隔（秒）
            DIFFERENCE_JSON_CHECK_INTERVAL: 15,

            // JSON差異用のインターバルID
            _intervalIDDifferenceJsonCheck: 0,

            // 自動更新処理のタイムアウトID
            _timeoutIDreserveAutoUpdate: 0,

            startup: function () {

                // 自動更新：開始
                this.own(topic.subscribe('app/control/SignageControl::start', lang.hitch(this, function (payload) {
                    this._initialUpdate = true;
                    this._signageList = payload;

                    // JSON差異チェック
                    this._intervalIDDifferenceJsonCheck = setInterval(lang.hitch(this, function() {
                        this.differenceJsonCheck();
                    }), this.DIFFERENCE_JSON_CHECK_INTERVAL * 1000);

                    // 更新予約
                    this.reserveAutoUpdate();
                })));

                // 自動更新：停止
                this.own(topic.subscribe('app/control/SignageControl::stop', lang.hitch(this, function () {
                    // JSON差異チェック処理の定期実行停止
                    if (this._intervalIDDifferenceJsonCheck > 0) {
                        clearInterval(this._intervalIDDifferenceJsonCheck);
                        this._intervalIDDifferenceJsonCheck = 0;
                    }
                    // 更新処理の実行予約取消
                    this.stopAutoUpdate();
                })));

                // 次画面遷移
                this.own(topic.subscribe('app/control/SignageControl::next', lang.hitch(this, function () {
                    this.nextAutoUpdate();
                })));

                // デジタルサイネージ表示画面でリロード時にはstartと同じ処理をする。
                const signage = sessionStorage.getItem("selectedSignage");
                if(signage){
                    const hasScreenId = Locator.getQuery().screenId;
                    if(hasScreenId){
                        const payload = JSON.parse(signage);
                        topic.publish('app/control/SignageControl::start', payload);
                    }
                }
            },

            // ウィジェットを破棄する
            destroy: function () {
                this.inherited(arguments);
                // 自動更新を解除
                this.stopAutoUpdate();
            },

            // JSON差異チェック
            differenceJsonCheck: function () {
                // 対象画面IDリスト
                var _screenIdList = [];
                // 対象ディスプレイ種別リスト
                var _displayTypeList = [];

                // サイネージリストの件数分繰り返す
                for (let i = 0; i < this._signageList.length; i++){
                    // 画面IDを対象画面IDリストに追加
                    var signageScreenId = this._signageList[i].screenId;
                    _screenIdList.push(signageScreenId);

                    // ディスプレイ種別を対象ディスプレイ種別リストに追加
                    var signageDisplayType = this._signageList[i].displayType;
                    _displayTypeList.push(signageDisplayType);
                }

                // 送信用データ
                var sendData = {
                    screenIdList : _screenIdList,
                    displayTypeList : _displayTypeList
                };

                // 送信用データをJSON化
                var jsonStr = json.stringify(sendData);

                Requester.post('/api/createSignage/differenceJsonCheck', {
                    data: jsonStr
                }).then(lang.hitch(this, function(returnVal) {
                    // JSON更新画面ID
                    var differJsonScreenId = returnVal;
                    
                    for (let i = 0; i < this._signageList.length; i++){
                        var signageScreenId = this._signageList[i].screenId;
                        console.log("　JSON差異チェックindex：" + i + "　画面ID：" + signageScreenId);

                        if (String(signageScreenId) === String(differJsonScreenId)) {
                            console.log("　JSON差異あり index：" + i + "　画面ID：" + signageScreenId);
                            // JSON差異有無フラグを立てる
                            this._differenceJsonFlg = true;
                            // JSON差異がある画面IDを表示する
                            this._signageIndex = i;
                            this.reserveAutoUpdate();
                            break;
                        }
                    }
                }), function(error) {
                    // 失敗時
                    console.error(error);
                });
            },

            // 自動更新を予約
            reserveAutoUpdate: function() { // １_更新タイミングで毎回呼ばれる ５_再帰的にこのメソッドが呼ばれる。以降繰り返し。
                // 既存の更新予約を解除
                this.stopAutoUpdate();

                // 初回更新
                if (this._initialUpdate) {
                    // 画面遷移
                    var signage = this._signageList[0];
                    Router.moveTo(signage.page, {
                        screenId: signage.screenId
                    });
                    // デジタルサイネージのヘッダーラベルを設定
                    topic.publish(module.id + '::setSignageHeaderLabel', signage);
                    // 表示データを保持しておく
                    this._prevSignage = signage;
                    // 初回更新フラグ降ろす
                    this._initialUpdate = false;
                }

                // JSONに差異がある場合
                if (this._differenceJsonFlg) {

                    var signage = this._signageList[this._signageIndex];
                    if (this._prevSignage.page === signage.page) {
                        // リフレッシュ
                        topic.publish(module.id + '::refresh', signage);
                    } else {
                        // 画面遷移
                        Router.moveTo(signage.page, {
                            screenId: signage.screenId
                        });
                    }
                    // デジタルサイネージのヘッダーラベルを設定
                    topic.publish(module.id + '::setSignageHeaderLabel', signage);
                    // 表示データを保持しておく
                    this._prevSignage = signage;
                    // JSON差異有無フラグを降ろす
                    this._differenceJsonFlg = false;
                }

                // 次回更新の予約
                this._timeoutIDreserveAutoUpdate = setTimeout(lang.hitch(this, function() {
                    this.nextAutoUpdate();
                }), this._prevSignage.frequency * 1000);
            },

            // 次のサイネージに遷移
            nextAutoUpdate: function () {

                // 次回更新の予約
                if (this._signageIndex + 1 === this._signageList.length) {
                    this._signageIndex = 0; // 先頭画面に戻る
                } else {
                    this._signageIndex += 1; // 次の画面
                }
                var signage = this._signageList[this._signageIndex];
                if (this._prevSignage.page === signage.page) {
                    // リフレッシュ
                    topic.publish(module.id + '::refresh', signage);
                } else {
                    // 画面遷移
                    Router.moveTo(signage.page, {
                        screenId: signage.screenId
                    });
                }
                // デジタルサイネージのヘッダーラベルを設定
                topic.publish(module.id + '::setSignageHeaderLabel', signage);
                // 表示データを保持しておく
                this._prevSignage = signage;
                console.log("画面ID：" + this._prevSignage.screenId + "を" + this._prevSignage.frequency + "秒待機");
                this.reserveAutoUpdate();
            },

            // 自動更新処理の実行予約取消
            stopAutoUpdate: function () {
                if (this._timeoutIDreserveAutoUpdate > 0) {
                    clearTimeout(this._timeoutIDreserveAutoUpdate);
                }
                this._timeoutIDreserveAutoUpdate = 0;
            },

            postCreate: function(){
                this.inherited(arguments);
                // ブラウザバックした時にタイトルが反映されるようにする。
                this.own(on(window, "popstate", function(){
                    const signage = sessionStorage.getItem("selectedSignage");
                    const payload = JSON.parse(signage);
                    topic.publish('app/control/SignageControl::start', payload);
                }));
            },

        });
});
